var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "btn/close"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6569 9.34313C19.6805 8.36682 18.0976 8.36682 17.1213 9.34313L15 11.4645L12.8787 9.34313C11.9024 8.36682 10.3195 8.36682 9.34315 9.34313C8.36684 10.3194 8.36684 11.9024 9.34315 12.8787L11.4645 15L9.34315 17.1213C8.36684 18.0976 8.36684 19.6805 9.34315 20.6568C10.3195 21.6332 11.9024 21.6332 12.8787 20.6568L15 18.5355L17.1213 20.6568C18.0976 21.6332 19.6805 21.6332 20.6569 20.6568C21.6332 19.6805 21.6332 18.0976 20.6569 17.1213L18.5355 15L20.6569 12.8787C21.6332 11.9024 21.6332 10.3194 20.6569 9.34313Z",
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6569 9.34313C19.6805 8.36682 18.0976 8.36682 17.1213 9.34313L15 11.4645L12.8787 9.34313C11.9024 8.36682 10.3195 8.36682 9.34315 9.34313C8.36684 10.3194 8.36684 11.9024 9.34315 12.8787L11.4645 15L9.34315 17.1213C8.36684 18.0976 8.36684 19.6805 9.34315 20.6568C10.3195 21.6332 11.9024 21.6332 12.8787 20.6568L15 18.5355L17.1213 20.6568C18.0976 21.6332 19.6805 21.6332 20.6569 20.6568C21.6332 19.6805 21.6332 18.0976 20.6569 17.1213L18.5355 15L20.6569 12.8787C21.6332 11.9024 21.6332 10.3194 20.6569 9.34313Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 30,
    height: 30,
    fill: "#E8703C"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.592cf087e786cf2391f8f76e62b0f6dc.svg";
export { ForwardRef as ReactComponent };